"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCounter = void 0;
var react_1 = require("react");
function useCounter() {
    return (0, react_1.useReducer)(function (x) { return x + 1; }, 0);
}
exports.useCounter = useCounter;
